import * as tslib_1 from "tslib";
import { MatPaginatorIntl } from '@angular/material/paginator';
var ItaPaginatorIntl = /** @class */ (function (_super) {
    tslib_1.__extends(ItaPaginatorIntl, _super);
    function ItaPaginatorIntl() {
        var _this = _super.call(this) || this;
        _this.totalCapped = false;
        // MatPaginatorIntl dichiara getRangeLabel come proprietà, non come metodo
        _this.getRangeLabel = function (page, pageSize, length) {
            if (length == 0 || pageSize == 0) {
                return "0 su " + length;
            }
            length = Math.max(length, 0);
            var startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            var endIndex = startIndex < length
                ? Math.min(startIndex + pageSize, length)
                : startIndex + pageSize;
            if (_this.totalCapped) {
                return startIndex + 1 + " - " + endIndex + " di oltre " + length + "+";
            }
            return startIndex + 1 + " - " + endIndex + " su " + length;
        };
        _this.itemsPerPageLabel = 'Elementi per pagina:';
        _this.nextPageLabel = 'Pagina successiva';
        _this.previousPageLabel = 'Pagina precedente';
        _this.lastPageLabel = 'Ultima pagina';
        _this.firstPageLabel = 'Prima pagina';
        return _this;
    }
    /**
     * Il backend limita il conteggio (meta.total_capped) per evitare COUNT(*) inefficienti:
     * in quel caso il totale è un minimo e la label lo esplicita.
     */
    ItaPaginatorIntl.prototype.setTotalCapped = function (capped) {
        if (this.totalCapped === capped)
            return;
        this.totalCapped = capped;
        this.changes.next();
    };
    return ItaPaginatorIntl;
}(MatPaginatorIntl));
export { ItaPaginatorIntl };
export function getItaPaginatorIntl() {
    return new ItaPaginatorIntl();
}
